import '@css/user_rankings/common.scss'

$(function () {
  $(".js_rv_images").each(function () {
    let $this = $(this);
    let $images = $this.find(".review-img-bg");
    let imageCount = $images.length;
    let currentIndex = 0;
    
    if (imageCount > 1) {
      $this.find(".js-next").on('click', function (e) {
        e.preventDefault();
        
        $images.eq(currentIndex).removeClass("active");
        currentIndex = (currentIndex + 1) % imageCount;
        $images.eq(currentIndex).addClass("active");
      });

      $this.find(".js-previous").on('click', function (e) {
        e.preventDefault();
        $images.eq(currentIndex).removeClass("active");
        currentIndex = (currentIndex - 1 + imageCount) % imageCount;
        $images.eq(currentIndex).addClass("active");
      });
    }
  });
})